var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "data-cy": "baseModalForm"
    }
  }, [_c('v-container', {
    class: {
      'pa-0': _vm.noContainer
    }
  }, [_vm.headline ? _c('v-card-title', {
    staticClass: "base-modal-form__header d-flex align-center"
  }, [_vm._t("headline", function () {
    return [_c('span', {
      staticClass: "headline",
      attrs: {
        "data-cy": "headline"
      }
    }, [_vm._v(_vm._s(_vm.headline))])];
  }), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Lukk",
      "data-cy": "modal-close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 2) : _vm._e(), _c('v-card-text', [_vm._t("default")], 2), _vm._t("after-card"), _c('v-card-actions', {
    staticClass: "base-modal-form__actions"
  }, [_c('v-spacer'), _vm._t("actions", function () {
    return [_c('v-btn', {
      attrs: {
        "elevation": "2",
        "primary": "",
        "large": ""
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v("Avbryt")]), !_vm.readonly ? _c('v-btn', {
      attrs: {
        "elevation": "2",
        "color": _vm.submitButtonColor,
        "loading": _vm.loading,
        "data-cy": "modal-submit",
        "large": ""
      },
      on: {
        "click": _vm.submitForm
      }
    }, [_vm._v(_vm._s(_vm.submitButtonText))]) : _vm._e()];
  }, {
    "close": _vm.close,
    "submitForm": _vm.submitForm,
    "readonly": _vm.readonly
  })], 2)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }